<template>
  <div class="behavior" v-loading="loading">
    <div class="section">
      <div class="section-title">分享概况</div>
      <el-row :gutter="16">
        <el-col :span="8" v-for="item in cards" :key="item.label">
          <div class="stat-card">
            <div class="label">{{ item.label }}</div>
            <div class="value">{{ item.value }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="section">
      <div class="section-title">分享排行 Top10</div>
      <el-table :data="rankList" border size="small">
        <el-table-column type="index" label="排名" width="70" align="center" />
        <el-table-column prop="name" label="成员" align="center" show-overflow-tooltip />
        <el-table-column prop="shareCount" label="分享次数" align="center" />
        <el-table-column prop="shareUserCount" label="分享人数" align="center" />
      </el-table>
    </div>
  </div>
</template>

<script>
import { shareSituation, shareTopN } from '@/api/radar'

export default {
  name: 'BehaviorAnalysis',
  data() {
    return {
      loading: false,
      overview: {},
      rankList: []
    }
  },
  computed: {
    cards() {
      const o = this.overview || {}
      return [
        { label: '分享次数', value: o.shareCount || o.totalShareCount || 0 },
        { label: '分享人数', value: o.shareUserCount || o.totalShareUserCount || 0 },
        { label: '新增客户', value: o.newCustomerCount || o.addCustomerCount || 0 }
      ]
    }
  },
  created() {
    this.load()
  },
  methods: {
    async load() {
      this.loading = true
      try {
        const [sit, top] = await Promise.all([
          shareSituation({ timeType: 0 }),
          shareTopN({ topN: 10, timeType: 0 })
        ])
        this.overview = (sit && sit.data) || {}
        this.rankList = (top && top.data) || []
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.section { margin-bottom: 28px; }
.section-title {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
}
.stat-card {
  background: #f7fafa;
  border-radius: 8px;
  padding: 16px 20px;
  .label { color: #8a8f93; font-size: 13px; }
  .value { color: #51cbcd; font-size: 28px; font-weight: 700; margin-top: 8px; }
}
</style>
